'use strict';

var React = require('react'),
    _ = require('lodash'),
    IconValueLeft = require('../Icon/IconValue/IconValueLeft'),
    Checkbox = require('./Checkbox');

module.exports = React.createClass({
    displayName: 'exports',


    propTypes: {
        value: React.PropTypes.any,
        options: React.PropTypes.array,
        onChange: React.PropTypes.func,
        checkIcon: React.PropTypes.string,
        uncheckIcon: React.PropTypes.string,
        isEnabled: React.PropTypes.bool,
        className: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array])
    },

    getDefaultProps: function getDefaultProps() {
        return {
            value: false,
            isEnabled: true,
            onChange: _.noop,
            checkIcon: "img/icoCheckboxChecked.png",
            uncheckIcon: "img/icoCheckboxUnChecked.png",
            options: [{ label: 'Yes', value: true }, { label: 'No', value: false }],
            uniqueElementId: _.uniqueId("prefix-")
        };
    },

    onChange: function onChange(item) {
        var self = this;
        return function () {
            self.props.onChange(item);
        };
    },

    renderItem: function renderItem(item, index) {
        var checked = this.props.value == item.value;

        var classNames = _.concat(['radio-button'], this.props.className),
            icon = checked ? this.props.checkIcon : this.props.uncheckIcon;

        if (this.props.isEnabled) {
            classNames.push('clickable');
        } else {
            classNames.push('disabled');
        }

        var uniqueElementId = this.props.uniqueElementId + index;

        return React.createElement(
            'li',
            { key: index, className: 'radio-button-item' },
            React.createElement(
                Checkbox,
                { label: item.label, checked: checked, onChange: this.onChange(item.value), checkIcon: this.props.checkIcon, uncheckIcon: this.props.uncheckIcon },
                item.component ? item.component : ""
            )
        );
    },

    render: function render() {

        var classNames = _.concat(['radio-buttons-list'], this.props.className);

        var itemComponents = _.map(this.props.options, this.renderItem);

        return React.createElement(
            'ul',
            { className: classNames.join(' ') },
            itemComponents
        );
    }

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Forms/RadioButton.js
// module id = 857
// module chunks = 2 3 5 8 25